import { useMutation } from 'react-query';
import {
  createEscolaWebIntegrationAsync,
  deleteEscolaWebIntegrationAsync,
  getAllEscolaWebIntegrationsAsync,
  getEscolaWebIntegrationByIdAsync,
  updateEscolaWebIntegrationAsync,
} from '../../index';

export const useCreateEscolaWebIntegrationAsync = () =>
  useMutation(createEscolaWebIntegrationAsync);

export const useGetEscolaWebIntegrationByIdAsync = () =>
  useMutation(getEscolaWebIntegrationByIdAsync);

export const useGetAllEscolaWebIntegrationsAsync = () =>
  useMutation(getAllEscolaWebIntegrationsAsync);

export const useUpdateEscolaWebIntegrationAsync = () =>
  useMutation(updateEscolaWebIntegrationAsync);

export const useDeleteEscolaWebIntegrationAsync = () =>
  useMutation(deleteEscolaWebIntegrationAsync);
